import { useEffect, useState } from "react";
import classNames from "classnames";
import { NavigationMenuItem } from "@idw-types/common";
import { NavigationMenuListContainer } from "../navigation-menu-list-container/navigation-menu-list-container";
import { NavigationMenuListItem } from "../navigation-menu-list-item/navigation-menu-list-item";
import styles from "./navigation-menu-list.less";

type NavigationMenuListProps = {
    handleExpandVerticallyClick: () => void;
    collapsedHorizontally: boolean;
    item: NavigationMenuItem;
    depthLevel: number;
}
export const NavigationMenuList = (props: NavigationMenuListProps) => {
    const { handleExpandVerticallyClick, collapsedHorizontally, item, depthLevel } = props;
    const [expanded, setExpanded] = useState(depthLevel === 0);

    useEffect(() => {
        if (collapsedHorizontally) {
            setExpanded(false);
        }
    }, [collapsedHorizontally]);

    const onListItemClick = () => {
        if (collapsedHorizontally && !expanded) {
            handleExpandVerticallyClick();
        }
        setExpanded((prevExpanded) => !prevExpanded);
    };

    return (
        <>
            <NavigationMenuListItem
                collapsedHorizontally={collapsedHorizontally}
                item={item}
                onListItemClick={onListItemClick}
                expanded={expanded}
                depthLevel={depthLevel}
            />
            {expanded && (
                <ul className={classNames(styles.navigationMenuList, !expanded ? styles.shrink : "")}>
                    {item.children.map(childItem => (
                        <NavigationMenuListContainer
                            key={`nav-menu-list-container-${childItem.title}`}
                            handleExpandVerticallyClick={handleExpandVerticallyClick}
                            collapsedHorizontally={collapsedHorizontally}
                            item={childItem}
                            depthLevel={depthLevel + 1}
                        />
                    ))}
                </ul>
            )}
        </>
    );
};